import React, { useEffect, useRef } from "react";
import QRCode from "qrcode";

// ATUALIZADO: Adicionamos a propriedade `qrColor` para personalizar a cor
const QRCodeWithLogo = ({
  text,
  logoSrc,
  width = 256,
  qrColor = "#000000",
}) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const generateQrCode = async () => {
      try {
        if (!text || !canvasRef.current) return;

        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");

        const qrCodeOptions = {
          errorCorrectionLevel: "H",
          margin: 3,
          width: width,
          color: {
            dark: qrColor, // Usa a cor passada pela propriedade
            light: "#FFFFFF",
          },
        };

        // Passo 1: Limpa o canvas antes de desenhar para evitar sobreposição
        context.clearRect(0, 0, canvas.width, canvas.height);

        // Passo 2: Sempre desenha o QR Code base
        await QRCode.toCanvas(canvas, text, qrCodeOptions);

        // Passo 3: Se um logo for fornecido, desenha-o por cima
        if (logoSrc) {
          const logo = new Image();
          logo.src = logoSrc;

          // Habilita o uso de imagens de outras origens (CORS) se necessário
          logo.crossOrigin = "Anonymous";

          logo.onload = () => {
            const logoSize = qrCodeOptions.width * 0.25;
            const logoX = (qrCodeOptions.width - logoSize) / 2;
            const logoY = (qrCodeOptions.width - logoSize) / 2;
            const padding = 5;

            // Desenha um fundo branco atrás do logo para garantir a leitura
            context.fillStyle = "#FFFFFF";
            context.fillRect(
              logoX - padding,
              logoY - padding,
              logoSize + padding * 2,
              logoSize + padding * 2
            );

            // Desenha o logo
            context.drawImage(logo, logoX, logoY, logoSize, logoSize);
          };

          logo.onerror = () => {
            console.error("Falha ao carregar a imagem do logo.");
          };
        }
      } catch (error) {
        console.error("Falha ao gerar o QR Code:", error);
      }
    };

    generateQrCode();
  }, [text, logoSrc, width, qrColor]); // Adicionadas dependências para re-renderizar corretamente

  // O canvas precisa ter um tamanho fixo para o toDataURL funcionar corretamente
  return <canvas ref={canvasRef} width={width} height={width} />;
};

export default QRCodeWithLogo;
